import { Email as EmailIcon } from 'pcln-icons'
import React, { useState } from 'react'
import {
  EMAIL_REGEXP,
  FIRST_NAME_ERROR,
  LAST_NAME_ERROR,
  firstNameField,
  formInputField,
  lastNameField,
} from '../constants'
import OptInForm from './OptInForm'

const OptInFormEmail = ({
  isNameRequired,
  showNameFields,
  signUpState,
  termsText,
  handleFormSubmit,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('')
  const [firstNameInput, setFirstNameInput] = useState('')
  const [lastNameInput, setLastNameInput] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [firstNameError, setFirstNameError] = useState('')
  const [lastNameError, setLastNameError] = useState('')
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const [termsError, setTermsError] = useState(false)

  const isValidEmailAddress = (emailAddress) => {
    return emailAddress.match(EMAIL_REGEXP)
  }

  const handleCheckBoxChange = (e) => {
    setAgreedToTerms(e.target.checked)
    e.target.checked && setTermsError(false)
  }

  const handleSubmit = () => {
    let shouldSubmit = true

    const hasValue = inputValue.length > 0
    if (!hasValue || !isValidEmailAddress(inputValue)) {
      setErrorMessage(
        hasValue ? 'Please check the email address you have entered' : 'Please enter an email address'
      )
      shouldSubmit = false
    } else {
      setErrorMessage('')
    }

    if (termsText && !agreedToTerms) {
      setTermsError(true)
      shouldSubmit = false
    }

    if (showNameFields) {
      if (isNameRequired && firstNameInput.length === 0) {
        setFirstNameError(FIRST_NAME_ERROR)
        shouldSubmit = false
      } else {
        setFirstNameError('')
      }
      if (isNameRequired && lastNameInput.length === 0) {
        setLastNameError(LAST_NAME_ERROR)
        shouldSubmit = false
      } else {
        setLastNameError('')
      }

      if (shouldSubmit) {
        setFirstNameError('')
        setLastNameError('')
        setErrorMessage('')
        handleFormSubmit &&
          handleFormSubmit({ email: inputValue, firstName: firstNameInput, lastName: lastNameInput })
      }
    } else {
      if (shouldSubmit) {
        setErrorMessage('')
        handleFormSubmit && handleFormSubmit({ email: inputValue })
      }
    }
  }

  const handleChange = (e) => {
    let value = e.target.value

    switch (e.target.id) {
      case formInputField:
        // istanbul ignore else
        if (value !== inputValue) {
          setErrorMessage('')
        }
        setInputValue(value)
        break
      case firstNameField:
        // istanbul ignore else
        if (value !== firstNameInput) {
          setFirstNameError('')
        }
        setFirstNameInput(value)
        break
      case lastNameField:
        // istanbul ignore else
        if (value !== lastNameInput) {
          setLastNameError('')
        }
        setLastNameInput(value)
        break
    }
  }

  return (
    <OptInForm
      {...props}
      agreedToTerms={agreedToTerms}
      errorMessage={errorMessage}
      firstNameError={firstNameError}
      lastNameError={lastNameError}
      showNameFields={showNameFields}
      inputValue={inputValue}
      firstNameInput={firstNameInput}
      lastNameInput={lastNameInput}
      placeholderIcon={<EmailIcon data-testid='email-icon' color='primary' />}
      signUpState={signUpState}
      termsError={termsError}
      termsText={termsText}
      handleChange={handleChange}
      handleCheckBoxChange={handleCheckBoxChange}
      handleSubmit={handleSubmit}
    />
  )
}

export default OptInFormEmail
